import { render, staticRenderFns } from "./MeetingBriefing.vue?vue&type=template&id=6d643f02&scoped=true&"
import script from "./MeetingBriefing.vue?vue&type=script&lang=js&"
export * from "./MeetingBriefing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d643f02",
  null
  
)

export default component.exports